<template>
  <a-modal :open="open" @cancel="closeForm" style="width: 650px">
    <h2>Об отчетах</h2>
    <a-divider style="margin: 16px 0" />

    <div class="tests-list">
      <a-card v-for="testData in reportData" :key="testData.id">
        <div class="test-details-card-wrapper">
          <div class="test-image-wrapper">
            <img :src="testData.image" alt="Обложка" />
          </div>
          <div>
            <div>
              <span class="test-title">{{ testData.title }}</span>{{ testData.description }}
            </div>
            <div>
              <a-button class="secondary-button" @click="openLink(testData.link)">
                Подробнее на сайте
              </a-button>
            </div>
          </div>
        </div>
      </a-card>
    </div>

    <template #footer>
      <a-divider />
      <div class="action-buttons">
        <a-row justify="end" :gutter="8">
          <a-col>
            <a-button class="secondary-button" @click="closeForm">Закрыть</a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>
<script>

import Standard from "@/assets/images/passing_examples/standard.png";
import Full from "@/assets/images/passing_examples/full.png";
import Management from "@/assets/images/passing_examples/management.png";

export default {
  props: {
    open: Boolean,
  },
  emits: ['close'],
  setup(props, context) {

    const closeForm = () => {
      context.emit('close');
    }

    const reportData = [
      {
        title: 'Стандартный отчет',
        description: ' — оценивает способности эмоционального интеллекта и показывает, как сотрудник работает с эмоциями в профессиональной среде. Показывает сильные стороны, зоны развития и данные для планирования обучения.',
        link: 'https://way2wei.ru/product/tei-standartnyi-otcet',
        image: Standard,
        id: 1,
      },
      {
        title: 'Управленческий потенциал',
        description: ' — углубленный инструмент оценки топ-руководителей, проводимый совместно с дипломированным экспертом по ЭИ. Дает точное понимание сильных сторон, зон роста и формирует персональную траекторию развития.',
        link: 'https://way2wei.ru/product/tei-upravlencheskii-potentsial',
        image: Management,
        id: 2,
      },
      {
        title: 'Экспертный отчет',
        description: ' — выявляет потенциал сотрудников на основе эмоционального интеллекта и помогает выбирать будущих руководителей по объективным метрикам. Снижает риски ошибочных назначений и поддерживает формирование кадрового резерва.',
        link: 'https://way2wei.ru/product/tei-ekspertnyi-otcet-s-konsultatsciey',
        image: Full,
        id: 3,
      },
    ];

    const openLink = (link) => {
      window.open(link, "_blank");
    }

    return {
      closeForm,
      reportData,
      openLink
    }
  }
}
</script>

<style scoped lang="scss">
  .tests-list {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .secondary-button {
      margin-top: 16px;
    }
  }

  .test-details-card-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: $mobile-breakpoint) {
      flex-direction: column;
      justify-content: center;
    }
  }

  .test-title {
    font-weight: 600;
  }

  .test-image-wrapper img {
    width: 100px;
    max-height: 140px;
    object-fit: cover;
  }
</style>